
import { Vue, Component, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ViewportStoreModule } from "@stores/viewport.store";
import { apiService } from "@services/api.service";

const viewportStore = getModule(ViewportStoreModule);

@Component({
  name: "ci-peergroup-list",
})
export default class extends Vue {
  @Prop({ default: "buttons" }) variant!: "buttons" | "carousel";
  @Prop({ default: () => (peergroup: Products.PeergroupTile) => peergroup }) clickCallback!: (
    peergroup: Products.PeergroupTile
  ) => void;
  public peergroupTilesList: Products.PeergroupTile[] = [];

  get peergroups(): Products.PeergroupTile[] {
    return this.peergroupTilesList;
  }

  get pageSize(): number {
    if (["sm", "md", "lg"].includes(viewportStore.currentViewport)) return 4;
    else return 8;
  }

  get pages(): Products.PeergroupTile[][] {
    const cache: any[] = [];
    const tmp = [...this.peergroups];
    if (this.pageSize <= 0) return cache;
    while (tmp.length) cache.push(tmp.splice(0, this.pageSize));
    return cache;
  }

  public beforeMount(): void {
    apiService.peergroups.tiles().then((response) => {
      this.peergroupTilesList = response.data.tiles;
    });
  }
}
